import { useCallback, useEffect, useState } from "react";
import { LocalStorageKey, LocalStorageSchema, MyLocalStorage } from "../utils/storage";

const useStorageState = <K extends LocalStorageKey>(
  storageKey: K
) => {
  type Data = LocalStorageSchema[K];

  const [state, _setState] = useState<Data | null>(null);

  useEffect(() => {
    const data = MyLocalStorage[storageKey].get() as Data | null;
    _setState(data);
  }, [])

  const setState = useCallback((data: Data) => {
    _setState(data);
    (MyLocalStorage[storageKey].set as (d: Data) => void)(data);
  }, []);

  return [ state, setState ] as [ Data|null, (d: Data) => void ]
}

export default useStorageState;